import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  Box,
} from "@mui/material";
import { AccountCircle, Menu as MenuIcon } from "@mui/icons-material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EventNoteIcon from "@mui/icons-material/EventNote";
import GroupsIcon from "@mui/icons-material/Groups";
import SettingsIcon from "@mui/icons-material/Settings";
import TuneIcon from "@mui/icons-material/Tune";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore"; // Stelle sicher, dass du Firebase korrekt konfiguriert hast
import { db } from "../firebaseConfig"; // Passe den Pfad zu deiner Firebase-Konfigurationsdatei an
import { useTenant } from '../contexts/TenantContext'; // Importiere den useTenant-Hook

function HeaderBar({ onLogout }) { // Entferne tenantId aus den Props
  const { tenantId } = useTenant(); // Verwende den useTenant-Hook, um tenantId zu erhalten
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompanyData = async () => {
      if (!tenantId) return;
      try {
        const tenantDocRef = doc(db, 'tenants', tenantId);
        const tenantSnap = await getDoc(tenantDocRef);
        if (tenantSnap.exists()) {
          const tenantData = tenantSnap.data();
          setCompanyName(tenantData.companyName || '');
          setLogoUrl(tenantData.logoUrl || '');
        }
      } catch (err) {
        console.error('Fehler beim Abrufen der Unternehmensdaten:', err);
      }
    };
    fetchCompanyData();
  }, [tenantId]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setDrawerOpen(false);
  };

  const menuItems = [
    { text: "Dashboard", path: "/admin/dashboard", icon: <DashboardIcon /> },
    { text: "Tagesplan", path: "/schedule", icon: <EventNoteIcon /> },
    { text: "Terminarten", path: "/admin/appointment-types", icon: <SettingsIcon /> },
    { text: "Verfügbarkeit", path: "/manage-availability", icon: <TuneIcon /> },
    { text: "Mitarbeiter", path: "/admin/user-management", icon: <GroupsIcon /> },
  ];

  return (
    <AppBar position="static">
      <Toolbar>
        {isMobile && (
          <IconButton edge="start" color="inherit" onClick={() => toggleDrawer(true)}>
            <MenuIcon />
          </IconButton>
        )}
        {/* Firmenlogo und -name */}
        <Box display="flex" alignItems="center" sx={{ flexGrow: 1 }}>
          {logoUrl && (
            <Box component="img" 
                 src={logoUrl} 
                 alt="Firmenlogo" 
                 sx={{ height: 40, marginRight: 2 }} />
          )}
          <Typography variant="h6">
            {companyName || "Admin Panel"}
          </Typography>
        </Box>
        {!isMobile && (
          menuItems.map((item) => (
            <Typography
              key={item.text}
              variant="button"
              sx={{ margin: "0 1rem", cursor: "pointer" }}
              onClick={() => handleNavigation(item.path)}
            >
              {item.text}
            </Typography>
          ))
        )}
        <IconButton color="inherit" onClick={handleMenuOpen}>
          <AccountCircle />
        </IconButton>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
          <MenuItem onClick={onLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
      <Drawer anchor="left" open={drawerOpen} onClose={() => toggleDrawer(false)}>
        <List>
          {menuItems.map((item) => (
            <ListItem button key={item.text} onClick={() => handleNavigation(item.path)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
}

export default HeaderBar;
